import PropTypes from 'prop-types';
import styled from 'styled-components';

const IconCircle = styled.div`
  background-color: ${props => props.backgroundColor};
  color: ${props => props.color};
  height: ${props => props.size};
  width: ${props => props.size};
  line-height: ${props => props.size};
  text-align: center;
  border-radius: 50%;
  user-select: none;

  i {
    vertical-align: middle;
  }
`;

IconCircle.propTypes = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string
};

IconCircle.defaultProps = {
  backgroundColor: '#ccc',
  color: '#fff',
  size: '96px'
};

export default IconCircle;



// WEBPACK FOOTER //
// ./src/app/admin/components/IconCircle/index.js